import Promise from 'bluebird';
import _ from 'lodash';
import moment from 'moment';
import Vue from 'vue';
import KendoDialogComponent from '../../../modules/shared/components/kendo-dialog/kendo-dialog.component';

import { loading, unloading } from '../../shared';
import { notify, NOTIFY_TYPE } from '../../shared/notify';
import map from '../map';
// import 'mapbox.js';

const LayerControls = (name) => require('../../controls').get(name);
const LayerInfo = (name) => require('../../info').get(name);
const halo = () => require('./halo').default;

const capture = (() => {
    const _leafletImage = (mapContainer, screenSize) =>
        new Promise((resolve) => {
            // console.time('_leafletImage');
            // layers are drawn in the same order as they are composed in the DOM:
            // tiles, paths, and then markers
            // mapContainer.setZoom(Math.round(mapContainer.getZoom()));

            const cacheBusterDate = +new Date();

            if (!screenSize) {
                screenSize = {
                    width: mapContainer.getSize().x,
                    height: mapContainer.getSize().y
                };
            }

            // const screenSize = {
            //     width: 1280,
            //     height: 800
            // };

            // if (screenSize.width < 1280)
            //     screenSize.width = 1280;
            // if (screenSize.height < 800)
            //     screenSize.height = 800;

            const dimensions = { x: screenSize.width, y: screenSize.height };

            const mainCanvas = document.createElement('canvas');
            mainCanvas.width = dimensions.x;
            mainCanvas.height = dimensions.y;
            const mainCanvasCtx = mainCanvas.getContext('2d');
            mainCanvasCtx.fillStyle = 'rgba(255,255,255,1)';
            mainCanvasCtx.fillRect(0, 0, mainCanvas.width, mainCanvas.height);

            // blank canvas image when getImageCanvas get 404 error
            const blankCanvas = document.createElement('canvas');
            blankCanvas.width = 1;
            blankCanvas.height = 1;
            const blankCanvasCxt = blankCanvas.getContext('2d');
            blankCanvasCxt.fillStyle = 'rgba(255,255,255,1)';
            blankCanvasCxt.fillRect(0, 0, 1, 1);

            const mapLayers = [];
            mapContainer.eachLayer(l => mapLayers.push(l));

            const drawLegendsControl = () =>
                new Promise((resolve) => {
                    if ($('.layer-legend').length === 0 || $(mapContainer.getContainer()).find('.legend-item').length > 25) {
                        resolve(blankCanvas);
                    }

                    const pos = {
                        x: 10,
                        y: dimensions.y
                    };

                    const q = [];
                    $(mapContainer.getContainer()).find('.layer-legend').each((i, el) => {
                        const legendCanvas = L.DomUtil.create('canvas', '');
                        legendCanvas.width = 160;
                        legendCanvas.height = 55 + ($(el).find('.legend-item').length * 20);
                        const legendCtx = legendCanvas.getContext('2d');
                        legendCtx.font = '12px Arial, Sans-serif';
                        legendCtx.lineWidth = 0.1;
                        legendCtx.fillStyle = '#FFF';
                        legendCtx.fillRect(0, 0, legendCanvas.width, legendCanvas.height);
                        legendCtx.strokeRect(0, 0, legendCanvas.width, legendCanvas.height);
                        legendCtx.fillStyle = '#000';
                        legendCtx.fillText($(el).find('.legend-title').text(), 10, 20);
                        legendCtx.fillText($(el).find('.legend-subtitle').text(), 10, 40);
                        $(el).find('.legend-item').each((k, kel) => {
                            legendCtx.fillStyle = $(kel).find('.legend-rect').css('background-color');
                            legendCtx.fillRect(10, 50 + (k * 20), 15, 15);
                            legendCtx.strokeRect(10, 50 + (k * 20), 15, 15);
                            legendCtx.fillStyle = '#000';
                            legendCtx.fillText($(kel).find('.legend-text').text(), 35, 63 + (k * 20));
                        });

                        pos.y = pos.y - pos.x - legendCanvas.height;
                        q.push(drawCanvas({
                            src: legendCanvas,
                            pos
                        }));
                    });

                    Promise.all(q).then(response => resolve(response));
                });

            const drawSVGLayer = (tileLayer) =>
                new Promise((resolve) => {
                    let pos = L.DomUtil.getPosition(tileLayer);

                    if (!pos) {
                        resolve(blankCanvas);
                    }

                    const svgData = new XMLSerializer().serializeToString(tileLayer._container);
                    const svg = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });

                    return getImageCanvas(URL.createObjectURL(svg), pos, {
                        width: tileLayer._svgSize.x,
                        height: tileLayer._svgSize.y
                    }).then(response => resolve(response));
                });

            const drawTileLayer = lyrs =>
                new Promise(resolve => {
                    const q = [];
                    _.forEach(lyrs, l => {
                        if (l instanceof (L.TileLayer || L.GridLayer)) {
                            q.push(handleTileLayer(l));
                        } else if (l._heat) {
                            q.push(handlePathRoot(l._canvas));
                        } else if (l._svgSize) {
                            q.push(drawSVGLayer(l));
                        }
                    });

                    Promise.all(q).then(response => resolve(response));
                });

            const drawMarkerLayer = lyrs =>
                new Promise((resolve) => {
                    const q = [];
                    _.forEach(lyrs, (l) => {
                        if (l instanceof L.Marker && l.options.icon instanceof L.Icon) {
                            q.push(handleMarkerLayer(l));
                        } else if (l instanceof L.MarkerClusterGroup) {
                            _.forEach(l._featureGroup._layers, val => q.push(handleMarkerLayer(val, true)));
                        }
                    });

                    Promise.all(q).then(response => resolve(response));
                });

            const composeCanvas = (images) => {
                if (_.isArray(images)) {
                    _.forEach(images, (image) => {
                        if (!image) return;
                        composeCanvas(image);
                    });
                    return;
                }

                try {
                    mainCanvasCtx.drawImage(images, 0, 0);
                } catch (err) {
                    console.log(err);
                }
            };

            const drawCanvas = img =>
                new Promise((resolve) => {
                    const canvas = document.createElement('canvas');
                    canvas.width = dimensions.x;
                    canvas.height = dimensions.y;
                    const ctx = canvas.getContext('2d');
                    try {
                        if (img.size) {
                            ctx.drawImage(img.src, Math.floor(img.pos.x), Math.floor(img.pos.y), img.size.width, img.size.height);
                        } else {
                            ctx.drawImage(img.src, Math.floor(img.pos.x), Math.floor(img.pos.y));
                        }

                        resolve(canvas);
                    } catch (err) {
                        console.log('Element could not be drawn on canvas');
                        resolve(blankCanvas);
                    }
                });

            const getImageCanvas = (url, pos, size) =>
                new Promise((resolve) => {
                    const img = new Image();
                    img.crossOrigin = 'Anonymous';

                    img.onload = () =>
                        resolve(drawCanvas({
                            src: img,
                            pos,
                            size
                        }));

                    img.onerror = e =>
                        resolve(drawCanvas({
                            src: blankCanvas,
                            pos,
                            size
                        }));

                    img.src = url;
                });

            const calculatePadding = (px) => {
                if (px.max.x < px.min.x + dimensions.x) {
                    const pad = Math.abs(((px.min.x + dimensions.x) - px.max.x) / 2);
                    px.min.x = px.min.x - pad;
                    px.max.x = px.min.x + dimensions.x;
                }

                if (px.max.y < px.min.y + dimensions.y) {
                    const pad = Math.abs(((px.min.y + dimensions.y) - px.max.y) / 2);
                    px.min.y = px.min.y - pad;
                    px.max.y = px.min.y + dimensions.y;
                }

                const padding = {
                    x: ((px.max.x - px.min.x) - dimensions.x) / 2,
                    y: ((px.max.y - px.min.y) - dimensions.y) / 2,
                };

                return padding;
            };

            const getPixelBounds = (tileLayer, zoom = currentZoom) => {
                const px = tileLayer && tileLayer._getTiledPixelBounds
                    ? tileLayer._getTiledPixelBounds(mapContainer.getCenter(), zoom, zoom)
                    : tileLayer._bounds || mapContainer.getPixelBounds();
                const padding = calculatePadding(px);

                const min = L.point(px.min.x + padding.x, px.min.y + padding.y);
                const max = L.point(px.max.x - padding.x, px.max.y - padding.y);

                return L.bounds(min, max);
            };

            const handleTileLayer = tileLayer =>
                new Promise(resolve => {
                    const isCanvasLayer = (L.TileLayer.Canvas && tileLayer instanceof L.TileLayer.Canvas);
                    let tileSize = tileLayer.getTileSize().x;

                    if (currentZoom > tileLayer.options.maxZoom ||
                        currentZoom < tileLayer.options.minZoom ||
                        (tileLayer.options.format && !tileLayer.options.tiles)) {
                        resolve(blankCanvas);
                    }

                    const tileBounds = L.bounds(
                        pixelBounds.min.divideBy(tileSize).floor(),
                        pixelBounds.max.divideBy(tileSize).floor()
                    );

                    const tiles = [];
                    _.forEach(_.rangeRight(tileBounds.min.x, tileBounds.max.x + 1), x =>
                        _.forEach(_.range(tileBounds.min.y, tileBounds.max.y + 1), y => {
                            tiles.push(L.point(x, y, currentZoom));
                        })
                    );

                    const q = [];
                    _.forEach(tiles, tile => {
                        const tileClone = tile.clone();

                        const pos = tileClone
                            .scaleBy(L.point(tileSize, tileSize))
                            .subtract(pixelBounds.min);

                        if (tile.y >= 0) {
                            if (tileLayer.getTileUrl) {
                                const url = addCacheString(tileLayer.getTileUrl(tile));
                                q.push(getImageCanvas(url, pos, { width: tileSize, height: tileSize }));
                            } else {
                                if (isCanvasLayer) {
                                    tile = tileLayer._tiles[`${tile.x}:${tile.y}`];
                                } else if (tileLayer.options.tiles && tileLayer.options.format && tileLayer.scalePrefix) {
                                    const pow = Math.pow(2, currentZoom + L.Browser.retina);
                                    tileSize = (tileSize % pow + pow) % pow;
                                    tile = tileLayer._tiles[`${tile.x}:${tile.y}:${currentZoom}`];
                                }

                                q.push(drawCanvas({
                                    src: tile,
                                    pos,
                                    size: { width: tileSize, height: tileSize }
                                }));
                            }
                        }
                    });

                    Promise.all(q).then(response => resolve(response));
                });

            const handlePathRoot = tileLayer =>
                new Promise(resolve => {
                    let pos = L.DomUtil.getPosition(tileLayer);
                    // svg images (d3 maps) are different
                    if (!pos) {
                        resolve(blankCanvas);
                    }

                    // pos = pos.subtract(pixelBounds.min).add(origin);
                    return drawCanvas({
                        src: tileLayer,
                        pos
                    }).then(response => resolve(response));
                });

            const handleMarkerLayer = (marker, cluster = false) => {
                const pixelPoint = mapContainer.project(marker.getLatLng(), currentZoom);

                const isBase64 = /^data:/.test(marker._icon.src);
                const url = isBase64 ? marker._icon.src : addCacheString(marker._icon.src);
                let size, anchor;
                if (cluster) {
                    size = [marker._icon.width, marker._icon.height];
                    anchor = L.point([+$(marker._icon).css('margin-left').replace('px', '') * -1, +$(marker._icon).css('margin-top').replace('px', '') * -1] || size.map(s => s / 2));
                } else {
                    const { options } = marker.options.icon;
                    if (options.iconSize instanceof L.Point) {
                        size = [options.iconSize.x, options.iconSize.y];
                        anchor = L.point(options.iconAnchor || size.map(s => s / 2));
                    } else {
                        size = options.iconSize;
                        anchor = L.point(options.iconAnchor || (size && size.divideBy(2, true)));
                    }
                }

                const pos = pixelPoint.subtract(pixelBounds.min);
                const x = Math.floor((pos.x - size[0]) + anchor.x);
                const y = Math.floor(pos.y - anchor.y);

                return getImageCanvas(url, { x, y }, { width: size[0], height: size[1] });
            };

            const addCacheString = (url) => {
                // If it's a data URL we don't want to touch this.
                if (!url || isDataURL(url)) { return url; }

                return url + (url.match(/\?/) ? '&' : '?') + 'cache=' + cacheBusterDate;
            };

            const isDataURL = url => {
                const dataURLRegex = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;
                return !!url.match(dataURLRegex);
            };

            const currentZoom = Math.round(mapContainer.getZoom());
            // const origin = mapContainer.getPixelOrigin();
            const pixelBounds = getPixelBounds(_.find(mapLayers, l => l instanceof (L.TileLayer || L.GridLayer)));

            const queue = [];
            queue.push(drawTileLayer(mapLayers));
            if (mapContainer._pathRoot) {
                queue.push(handlePathRoot(mapContainer._pathRoot));
            } else if (mapContainer._panes && mapContainer._panes.overlayPane.getElementsByTagName('canvas').item(0)) {
                queue.push(handlePathRoot(mapContainer._panes.overlayPane.getElementsByTagName('canvas').item(0)));
            }

            queue.push(drawMarkerLayer(mapLayers));
            queue.push(drawLegendsControl());

            Promise.all(queue).then((response) => {
                composeCanvas(response);
                // console.timeEnd('_leafletImage');
                resolve(mainCanvas);
            });
        });

    let locked = false;
    const _createImage = (autosave) => new Promise((resolve, reject) => {
        const zoom = map.getCurrent().getZoom();
        if (!_.isInteger(zoom)) {
            const el = document.createElement('div');
            return new Vue({
                el,
                components: {
                    kendoDialog: KendoDialogComponent
                },
                data () {
                    return {
                        content: 'Nível de zoom não suportado pela ferramenta de captura, deseja ajustar automaticamente?',
                        actions: [{
                            text: 'Cancelar',
                            action: this.onCancel
                        }, {
                            text: 'Confirmar',
                            primary: true,
                            action: this.onConfirm
                        }]
                    };
                },
                methods: {
                    onConfirm: () => {
                        notify(NOTIFY_TYPE.LOG, 'Ajustando nível de zoom para captura, tente novamente');
                        map.getCurrent().setZoom(Math.round(zoom));
                    },
                    onCancel: () => {
                    }
                },
                template: `
                    <kendo-dialog 
                        :content="content" 
                        :actions="actions" 
                        :visible="true">
                    </kendo-dialog>`
            });
        }

        if (locked) return;
        locked = true;

        if (!autosave) { loading(); }
        LayerInfo('SelectedAreas').blank();
        LayerInfo('MarkedArea').blank();
        LayerInfo('DncFlexible').blank();

        setTimeout(() =>
            map.get().eachMap((m) => {
                _leafletImage(m).then((canvas) => {
                    if (!autosave) { unloading(); }
                    locked = false;

                    if (autosave) {
                        kendo.saveAs({
                            dataURI: canvas.toDataURL('image/png'),
                            fileName: `screenshot_${moment().format('YYYYMMDD')}.png`
                        });
                        // const image = new Image();
                        // image.src = canvas.toDataURL('image/png');
                        // window.open(image.src, '_blank');
                    } else {
                        return resolve(canvas);
                    }
                });
            }), 300);
    });

    const _disableNonPrintableLayers = () => {
        if (LayerControls('Customers').check()) {
            const layer = LayerControls('Customers').getLayer();
            if (layer.checkType('default')) {
                notify(NOTIFY_TYPE.ERROR, 'Captura de clientes desclusterizados não é possível.');
                return false;
            }
        }
        halo().remove();
        return true;
    };

    const get = (autosave = true) => {
        if (_disableNonPrintableLayers()) {
            return _createImage(autosave);
        }
    };

    return {
        get
    };
})();

export default capture;



// WEBPACK FOOTER //
// ./src/scripts/core/map/capture.js